import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-[#FAFAF9]">
      {/* Background radial gradient */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[70%] h-[70%] bg-[radial-gradient(ellipse_at_top_right,_#E6D9FF_0%,_transparent_65%)] opacity-60" />
        <div className="absolute bottom-0 left-0 w-[40%] h-[40%] bg-[radial-gradient(ellipse_at_bottom_left,_#F0EBFF_0%,_transparent_70%)] opacity-40" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 pt-24 pb-16 w-full">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-6">
          {/* Left Content */}
          <div
            className={`flex-1 max-w-xl transition-all duration-1000 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
          >
            {/* Pill label */}
            <div className="inline-flex items-center gap-2 bg-[#E6D9FF] text-[#5B3FA0] text-xs font-semibold px-4 py-1.5 rounded-full mb-8">
              <span className="w-1.5 h-1.5 rounded-full bg-[#9B72FF] inline-block animate-pulse"></span>
              Now in Early Access · Hong Kong
            </div>

            {/* Headline */}
            <h1 className="text-5xl md:text-6xl lg:text-[68px] leading-[1.08] font-semibold text-gray-900 mb-6">
              <span className="font-bold">Explore</span> <span className="font-light text-[#9B72FF]">interests.</span>
              <br />
              <span className="font-bold">Connect</span> <span className="font-light text-[#9B72FF]">deeply.</span>
              <br />
              <span className="font-bold">Meet IRL.</span>
            </h1>

            <p className="text-lg text-gray-500 leading-relaxed mb-10 max-w-md">
              Aurays helps you build real connections through shared interests — and bring them into real life.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-3 mb-10">
              <Link
                to="/register"
                className="bg-gray-900 text-white text-sm font-semibold px-7 py-3.5 rounded-full hover:bg-gray-700 transition-all duration-200 cursor-pointer whitespace-nowrap text-center"
              >
                Join Early Access
              </Link>
              <a
                href="#features"
                className="border border-gray-300 text-gray-700 text-sm font-semibold px-7 py-3.5 rounded-full hover:border-gray-500 hover:text-gray-900 transition-all duration-200 cursor-pointer whitespace-nowrap text-center"
              >
                Explore Features
              </a>
            </div>

            {/* Social proof */}
            <div className="flex items-center gap-3">
              <div className="flex -space-x-2">
                {["/aurays-ppl-1.jpg", "/aurays-ppl-2.jpg", "/aurays-ppl-3.jpg"].map((src, i) => (
                  <img
                    key={i}
                    src={src}
                    alt="User"
                    className="w-9 h-9 rounded-full border-2 border-white object-cover object-top"
                  />
                ))}
              </div>
              <p className="text-sm text-gray-500">
                <strong className="text-gray-900">500+</strong> people already joined
              </p>
            </div>
          </div>

          {/* Right — iPhone Mockups */}
          <div
            className={`flex-1 flex justify-center items-end relative transition-all duration-1000 delay-300 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}
          >
            <div className="relative w-[320px] md:w-[380px] h-[520px] md:h-[600px]">
              {/* Back image */}
              <div
                className="absolute left-0 bottom-0 w-[180px] md:w-[210px] transform -rotate-6 origin-bottom-right z-10 rounded-[28px] overflow-hidden"
                style={{ aspectRatio: "9/19.5" }}
              >
                <img
                  src="/aurays-app-screen-1.jpeg"
                  alt="Aurays app screen"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Front image */}
              <div
                className="absolute right-0 bottom-0 w-[195px] md:w-[220px] z-20 rounded-[30px] overflow-hidden"
                style={{ aspectRatio: "9/19.5" }}
              >
                <img
                  src="/aurays-app-screen-2.jpeg"
                  alt="Aurays app home"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Floating card */}
              <div
                className="absolute top-8 right-[-20px] md:right-[-10px] z-30 bg-white rounded-2xl px-4 py-3 border border-gray-100 animate-bounce"
                style={{ animationDuration: "3s" }}
              >
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0">
                    <img src="/aurays-ppl-4.jpg" alt="Match" className="w-full h-full object-cover object-top" />
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-gray-900 whitespace-nowrap">✨ New Match</p>
                    <p className="text-xs text-gray-400 whitespace-nowrap">Mei, 26</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-40">
        <span className="text-xs text-gray-400">Scroll</span>
        <i className="ri-arrow-down-line text-gray-400 animate-bounce"></i>
      </div>
    </section>
  );
}
